export * from './lib/desktop-right-sidebar.module';
export * from './lib/desktop-right-sidebar.component';
export * from './lib/desktop-right-sidebar.service';
